window.__tnt || (window.__tnt = {});
window.__tnt.service || (__tnt.service = {});
window.__tnt.service.dashboard || (__tnt.service.dashboard = {});

/******************************************************************************
 * Define variables for logging
 */
 
/* Track previous event called */
__tnt.service.dashboard.previousEvent = "";

/******************************************************************************
 * Initialize Events 
 */

/*
 * Subscription Cancellation Intended
 * @event #BLOXSubscriptionCancellationIntended
 */
logSubscriptionCancellationIntended = new CustomEvent('BLOXSubscriptionCancellationIntended', { detail: {} });

/*
 * Subscription Cancellation Continued
 * @event #BLOXSubscriptionCancellationContinued
 */
logSubscriptionCancellationContinued = new CustomEvent('BLOXSubscriptionCancellationContinued', { detail: {} });

/*
 * Subscription Retention Offers Viewed
 * @event #BLOXSubscriptionRetentionOffersViewed
 */
logSubscriptionRetentionOffersViewed = new CustomEvent('BLOXSubscriptionRetentionOffersViewed', { detail: {} });

/*
 * Subscription Rate Updated
 * @event #BLOXSubscriptionRateUpdated
 */
logSubscriptionRateUpdated = new CustomEvent('BLOXSubscriptionRateUpdated', { detail: {} });

/*
 * Subscription Cancellation Reason Entered
 * @event #BLOXSubscriptionCancellationReasonEntered
 */
logSubscriptionCancellationReasonEntered = new CustomEvent('BLOXSubscriptionCancellationReasonEntered', { detail: {} });

/*
 * Subscription Cancellation Confirmed
 * @event #BLOXSubscriptionCancellationConfirmed
 */
logSubscriptionCancellationConfirmed = new CustomEvent('BLOXSubscriptionCancellationConfirmed', { detail: {} });

/*
 * Subscription Cancellation Retracted
 * @event #BLOXSubscriptionCancellationRetracted
 */
logSubscriptionCancellationRetracted = new CustomEvent('BLOXSubscriptionCancellationRetracted', { detail: {} });


/******************************************************************************
 * Helper Functions 
 */

/*
 * setProduct
 * @sets object
 */
__tnt.service.dashboard.setProduct = function(data){
    try{
        if (data && data.product_id) {
            data.product_id = data.product_id.toString(); // Make sure product_id is a string

            __tnt.service.dashboard.productData = data;

            sessionStorage.setItem('__tnt.service.dashboard.productData', JSON.stringify(data));

            return data;
        } else { throw new Error("No product data found") }
    } catch(e){ return e }
};

/*
 * getProduct
 * @returns object
 */
__tnt.service.dashboard.getProduct = function(){
    if(__tnt.service.dashboard.productData){
        return __tnt.service.dashboard.productData;
    } else if(sessionStorage.getItem('__tnt.service.dashboard.productData')){
        __tnt.service.dashboard.productData = JSON.parse(sessionStorage.getItem('__tnt.service.dashboard.productData'));
        
        return __tnt.service.dashboard.productData;
    }
};

/*
 * rmProduct
 * @removes object
 */
__tnt.service.dashboard.rmProduct = function(){
    __tnt.service.dashboard.productData = null;
    
    try{
        sessionStorage.removeItem('__tnt.service.dashboard.productData')
    } catch(e){ }
    
    return false;
};
 
/******************************************************************************
 * Event Emitting Functions 
 */

/*
 * logCancelIntended
 * @fires #BLOXSubscriptionCancellationIntended
 */
 __tnt.service.dashboard.logCancelIntended = function(productData, contextData){
     var context = contextData;
    
     if (!contextData){
         context = "organic";
     }
     
     if(productData){
         __tnt.service.dashboard.setProduct(productData);
     
        logSubscriptionCancellationIntended.detail.service_id = productData.product_id;
        logSubscriptionCancellationIntended.detail.context = context;
        logSubscriptionCancellationIntended.detail.product = productData;
    
        window.dispatchEvent(logSubscriptionCancellationIntended);
        __tnt.service.dashboard.previousEvent = "Subscription Cancellation Intended";
    }
 }
 
/*
 * logCancelContinued
 * @fires #BLOXSubscriptionCancellationContinued
 */
 __tnt.service.dashboard.logCancelContinued = function(contextData){
    var product = __tnt.service.dashboard.getProduct();
    var context = contextData;
    
    if (!contextData){
        context = "organic";
    }
    
    if(product){
        logSubscriptionCancellationContinued.detail.context = context;
        logSubscriptionCancellationContinued.detail.product = product;
        
        window.dispatchEvent(logSubscriptionCancellationContinued);
        __tnt.service.dashboard.previousEvent = "Subscription Cancellation Continued";
    }
 }
 
/*
 * logOffersViewed
 * @fires #BLOXSubscriptionRetentionOffersViewed
 */
 __tnt.service.dashboard.logOffersViewed = function(products){
    var product = __tnt.service.dashboard.getProduct();
    
    if(product){
        logSubscriptionRetentionOffersViewed.detail.product = product;
        logSubscriptionRetentionOffersViewed.detail.products = products;
        
        window.dispatchEvent(logSubscriptionRetentionOffersViewed);
        __tnt.service.dashboard.previousEvent = "Subscription Retention Offers Viewed";
    }
 }
 
/*
 * logRateUpdated
 * @fires #BLOXSubscriptionRateUpdated
 */
 __tnt.service.dashboard.logRateUpdated = function(productData){
    if(productData){
        __tnt.service.dashboard.setProduct(productData);
        
        logSubscriptionRateUpdated.detail.product = productData;
        
        window.dispatchEvent(logSubscriptionRateUpdated);
        __tnt.service.dashboard.previousEvent = "Subscription Rate Updated";
        __tnt.service.dashboard.rmProduct();
    }
 }
 
/*
 * logCancelReason
 * @fires #BLOXSubscriptionCancellationReasonEntered
 */
 __tnt.service.dashboard.logCancelReason = function(cancelReason){
    var product = __tnt.service.dashboard.getProduct();
    
    if(product){
        logSubscriptionCancellationReasonEntered.detail.product = product;
        logSubscriptionCancellationReasonEntered.detail.cancellation_reason = cancelReason;
        
        window.dispatchEvent(logSubscriptionCancellationReasonEntered);
        __tnt.service.dashboard.previousEvent = "Subscription Cancellation Reason Entered";
    }
 }
 
/*
 * logCancelConfirmed
 * @fires #BLOXSubscriptionCancellationConfirmed
 */
 __tnt.service.dashboard.logCancelConfirmed = function(cancelReason){
    var product = __tnt.service.dashboard.getProduct();
    
    if(product){
        logSubscriptionCancellationConfirmed.detail.product = product;
        logSubscriptionCancellationConfirmed.detail.cancellation_reason = cancelReason;
        
        window.dispatchEvent(logSubscriptionCancellationConfirmed);
        __tnt.service.dashboard.previousEvent = "Subscription Cancellation Confirmed";
        __tnt.service.dashboard.rmProduct();
    }
 }

/*
 * logCancelRetracted
 * @fires #BLOXSubscriptionCancellationRetracted
 */
  __tnt.service.dashboard.logCancelRetracted = function(){
    var product = __tnt.service.dashboard.getProduct();
    var previousEvent = __tnt.service.dashboard.previousEvent;
    
    if(product){
        logSubscriptionCancellationRetracted.detail.product = product;
        logSubscriptionCancellationRetracted.detail.previous_event_name = previousEvent;
        
        window.dispatchEvent(logSubscriptionCancellationRetracted);
        __tnt.service.dashboard.previousEvent = "Subscription Cancellation Retracted";
        __tnt.service.dashboard.rmProduct();
    }
 }